import styled from "styled-components";
import { Link } from "react-router-dom";

const Styled = styled(Link)`
    display: inline-flex;
    align-items: center;
    gap: 8px;

    padding: 12px 18px;
    margin-top: 40px;

    border-radius: 12px;
    border: 1px solid black;

    text-decoration: none;
    color: black;

    background: #ffffff;
    font-weight: 600;

    transition: 0.2s ease;

    &:hover {
        background: #464646;
        color: white;
        transform: translateY(-2px);
    }
`;

function StyledLink({ destination, content }) {
    return (
        <Styled to={destination}>
            {content}
        </Styled>
    );
}

export default StyledLink;